(function($, window, document) {
	var $win = $(window);
	var $doc = $(document);

	$doc.ready(function() {
		var $body = $('body');

		var classes = {
			Hover       : 'hover',
			Active      : 'active',
			ShowNavMain : 'show-nav-main',
			FixedHeader : 'show-fixed-header',
			PageLoad    : 'page-load',
		};

		var is = {
			Mobile  : false,
			Desktop : false,
			Tablet  : false,
		};

		var get = {
			Scroll   : 0,
			WinWidth : 0,
		};

			/*
				# - Ready
			*/

		addDeviceResolution();
		addBaseClickEvents();
		sliderInit();
		browserFallback();
		showSearch();
		selectricInit();
		accordion();
		customUploadButton();
		moveUploadButton();
		showFileName();

			/*
				# - Load
			*/

		$win.on('load', function(){
			$body.addClass(classes.PageLoad);
			//initMap();
		});

			/*
				# - Scroll
			*/


		$win.on('scroll', function(){
			get.Scroll = $win.scrollTop();

			$body.toggleClass(classes.FixedHeader, (get.Scroll > 23));
		});

			/*
				- # - Resize Orientationchange
			*/

		$win.on('resize orientationchange', function(){
			addDeviceResolution();
			sliderInit();
		});

		/*
			# - Functions -	
		*/

		function customUploadButton() {
			$('.jsCustomUpload input[type="file"]').change(function(e){
				var $this = $(this);
				var $container = $this.parent();
	            var $label = $container.find('label');
	            var fileName;

	            if (e.target.value.length) {
	            	fileName = e.target.files[0].name;
					$label.text(fileName);
	            } else {
	            	$label.text('No file chosen');
	            }
	        });
		}

		function moveUploadButton() {
			var uploadLabel = $('.upload label');
			var cf7InputSpan = $('.upload .wpcf7-form-control-wrap');
			uploadLabel.prependTo(cf7InputSpan);
		}

		// File Input Name Return
		function showFileName() {
			$('input[type="file"]').each(function(){
				var input = this,
					$input = $(this),
					$output = $('<div class="file-label"></div>');
					$output.text('No File Chosen');
				$output.insertAfter($input);

				$input.change(() => {
					var filename = input.files[0].name;
					$output.text(filename);
				});
			});
		}

        /*window.initMap = function (){
			var $map = $('.map');

        	if (!$map.length) {
        		return false;
        	}

        	var fileName = $map.data('file-name');
        	var zoom;

        	if (is.Mobile) {
        		zoom = $map.data('zoom-mobile');
        	} else {
	        	zoom = $map.data('zoom');
        	}

			$.getJSON('ajax/google-map/' + fileName + '.json').then(function(data){
		        var activeWindow;
				var styles = [
				    {
				        'featureType': 'administrative',
				        'elementType': 'labels.text.fill',
				        'stylers': [
				            {
				                'color': '#444444',
				            },
				        ],
				    },
				    {
				        'featureType': 'landscape',
				        'elementType': 'all',
				        'stylers': [
				            {
				                'color': '#f2f2f2',
				            },
				        ],
				    },
				    {
				        'featureType': 'poi',
				        'elementType': 'all',
				        'stylers': [
				            {
				                'visibility': 'off',
				            },
				        ],
				    },
				    {
				        'featureType': 'poi.park',
				        'elementType': 'all',
				        'stylers': [
				            {
				                'visibility': 'on',
				            },
				            {
				                'color': '#e5e5e5',
				            },
				        ],
				    },
				    {
				        'featureType': 'poi.park',
				        'elementType': 'labels',
				        'stylers': [
				            {
				                'visibility': 'off',
				            },
				        ],
				    },
				    {
				        'featureType': 'road',
				        'elementType': 'all',
				        'stylers': [
				            {
				                'saturation': -100,
				            },
				            {
				                'lightness': 45,
				            },
				        ],
				    },
				    {
				        'featureType': 'road.highway',
				        'elementType': 'all',
				        'stylers': [
				            {
				                'visibility': 'simplified',
				            },
				            {
				                'color': '#dadada',
				            },
				            {
				                'weight': '3',
				            },
				        ],
				    },
				    {
				        'featureType': 'road.highway',
				        'elementType': 'labels',
				        'stylers': [
				            {
				                'visibility': 'off',
				            },
				        ],
				    },
				    {
				        'featureType': 'road.arterial',
				        'elementType': 'geometry',
				        'stylers': [
				            {
				                'weight': '1.451',
				            },
				        ],
				    },
				    {
				        'featureType': 'road.arterial',
				        'elementType': 'labels',
				        'stylers': [
				            {
				                'visibility': 'on',
				            },
				        ],
				    },
				    {
				        'featureType': 'road.arterial',
				        'elementType': 'labels.text',
				        'stylers': [
				            {
				                'color': '#7c7b7b',
				            },
				            {
				                'weight': '0.45',
				            },
				            {
				                'gamma': '1',
				            },
				        ],
				    },
				    {
				        'featureType': 'road.arterial',
				        'elementType': 'labels.icon',
				        'stylers': [
				            {
				                'visibility': 'off',
				            },
				        ],
				    },
				    {
				        'featureType': 'road.local',
				        'elementType': 'labels',
				        'stylers': [
				            {
				                'visibility': 'off',
				            },
				        ],
				    },
				    {
				        'featureType': 'transit.line',
				        'elementType': 'all',
				        'stylers': [
				            {
				                'weight': '1',
				            },
				        ],
				    },
				    {
				        'featureType': 'transit.station',
				        'elementType': 'all',
				        'stylers': [
				            {
				                'visibility': 'off',
				            },
				        ],
				    },
				    {
				        'featureType': 'water',
				        'elementType': 'all',
				        'stylers': [
				            {
				                'color': '#c9c9c9',
				            },
				            {
				                'visibility': 'on',
				            },
				        ],
				    },
				    {
				        'featureType': 'water',
				        'elementType': 'labels',
				        'stylers': [
				            {
				                'color': '#ffffff',
				            },
				        ],
				    },
				];

				var slat = parseFloat($map.data('lat'));
				var slng = parseFloat($map.data('lng'));
				var coordinates = {lat: slat, lng: slng};

				var mobileTrue = false;

				if (is.Mobile) {
					mobileTrue = true;
				}

				var map = new google.maps.Map(document.getElementById('map'), {
				    zoom: zoom,
				    center: coordinates,
				    styles: styles,
				    disableDefaultUI: mobileTrue,
				});

				data.forEach( function (pin) {
					var marker = new google.maps.Marker({
						map: map,
						position: {
							lat: pin.lat,
							lng: pin.lng,
						},
						icon: {
							url: pin.url,
							size: {
								width: pin.width/2,
								height: pin.height/2,
							},
							scaledSize: {
								width: pin.width/2,
								height: pin.height/2,
							},
						},
					});

					if (pin.info.length) {
						var infowindow = new google.maps.InfoWindow({
							content: pin.info,
							maxWidth: 188,
				        });

				        marker.addListener('click', function(){						
							if(activeWindow != null) {
								activeWindow.close(); 
							}

						    infowindow.open(map, marker); 
						    
						    activeWindow = infowindow; 
						});
					}
				});
			});
		}*/

		function accordion() {
			$('.jsAccordion .accordion__head a').click(function(e){
				e.preventDefault();

				var $this = $(this);

				$this.closest('.accordion__section').toggleClass('expanded').find('.accordion__body').stop(true, false).slideToggle().parent().siblings().removeClass('expanded').find('.accordion__body').slideUp();
			});
		}

		function selectricInit() {
			$('.wpcf7-select').selectric({
				maxHeight: 200,
			});
			$('.news-filter-selector').selectric({
				maxHeight: 200,
			});
		}

		function showSearch() {
			$('.jsShowSearch').click(function(e){
				e.preventDefault();

				$(this).closest('.header').find('.searchhold').toggleClass('search-visible');
			});
		}

		function browserFallback() {
			// IE
			var ua = window.navigator.userAgent;
			var msie = ua.indexOf('MSIE ');
			var msedge = ua.indexOf('Edge');

			if (msedge > -1 || msie > 0 || !!navigator.userAgent.match(/Trident.*rv\11\./) || navigator.userAgent.match(/(iPod|iPhone|iPad)/)) { 
				$('html').addClass('browser-ie');
			}
		}

		function sliderInit() {
			var $sliderMobile = $('.jsSliderMobile');
			var $slider = $('.jsSlider');

			$slider.each(function(){
				if (!$slider.hasClass('slick-initialized')) {
					$slider.slick({
						dots: true,
						arrows: false,
					});
				}
			});

			$sliderMobile.each(function(){
				var $this = $(this);

				if (is.Mobile) {
					if (!$this.hasClass('slick-initialized')) {
						$this.slick({
							dots: true,
							arrows: false,
						});
					}
				} else {
					if ($this.hasClass('slick-initialized')) {
						$this.slick('unslick');
					}
				}
			});
		}

		function addBaseClickEvents() {
			$body.on('click touchstart', function(event){
				var $target = $(event.target);

				if(is.Tablet || is.Mobile){
					if(!$target.parents('.nav').length){
						$('.nav li').removeClass(classes.Hover);
					}
				}
			});

			$('.nav a').click(function(event){
				if(is.Tablet || is.Mobile){
					var $this = $(this);
					var $parent = $this.parent();

					if($parent.find('> ul').length && !$parent.hasClass(classes.Hover)){
						event.preventDefault();

						$parent.toggleClass(classes.Hover).siblings().removeClass(classes.Hover);
					}
				}
			});	
		}

		function addDeviceResolution() {
			get.WinWidth = $win.width();

			is.Desktop = (get.WinWidth > 985); 
			is.Mobile  = (get.WinWidth <= 767);
			is.Tablet  = (get.WinWidth <= 985 && get.WinWidth >= 768);
		}
	});

})(jQuery, window, document);



// WEBPACK FOOTER //
// ./scripts/routes/functions.js